import { api, transformResponse } from './axios'

export const fetchGetFio = (data: { fio: string }, token: string) =>
  transformResponse(
    api.post('/getFio', data, {
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    }),
  )
